@if (theme?.header?.show) {
  @if (theme.theme.mainTheme === 'Inera-admin') {
    <id-header-inera-admin [brandtext]="theme.header.name || 'IdP'"></id-header-inera-admin>
  } @else if (theme.theme.mainTheme === '1177') {
    <id-header-1177 [hideregionpicker]="true"></id-header-1177>
  } @else if (theme.theme.mainTheme === '1177-pro') {
    <id-header-1177-pro [hideregionpicker]="true"></id-header-1177-pro>
  } @else if (theme.theme.mainTheme === '1177-admin') {
    <id-header-1177-admin [brandtext]="theme.header.name"></id-header-1177-admin>
  } @else {
    <header id="header" class="custom-header">
      <div class="header-container">
        <h1 class="header-title">{{ theme.header.name || 'IdP' }}</h1>
        <img alt="Theme Icon" class="header-logo" [src]="theme.theme.icon" />
      </div>
    </header>
  }
}
